import { render, staticRenderFns } from "./DownloadSvg.vue?vue&type=template&id=627cbaa4&scoped=true&"
import script from "./DownloadSvg.vue?vue&type=script&lang=js&"
export * from "./DownloadSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cbaa4",
  null
  
)

export default component.exports